const _envConfig: { [key: string]: string | undefined } = {
  env: process.env['REACT_APP_ENVIRONMENT'],
  baseUrl: process.env['REACT_APP_BASE_URL'],
  releaseVersion: process.env['REACT_APP_VERSION'],
  firebaseApiKey: process.env['REACT_APP_FIREBASE_API_KEY'],
  firebaseAuthDomain: process.env['REACT_APP_FIREBASE_AUTH_DOMAIN'],
  firebaseProjectId: process.env['REACT_APP_FIREBASE_PROJECT_ID'],
  firebaseStorageBucket: process.env['REACT_APP_FIREBASE_STORAGE_BUCKET'],
  firebaseSenderId: process.env['REACT_APP_FIREBASE_SENDER_ID'],
  firebaseAppId: process.env['REACT_APP_FIREBASE_APP_ID'],
  firebaseMeasureId: process.env['REACT_APP_FIREBASE_MEASURE_ID'],
  stripeKey: process.env['REACT_APP_STRIPE_KEY'],
  universalLink: process.env['REACT_APP_UNIVERSAL_LINK'],
  domainUrl: process.env['REACT_APP_UI_DOMAIN_LINK'],
  amplitudeKey: process.env['REACT_APP_AMPLITUDE_API_KEY'],
  microsoftClarityProjectId:
    process.env['REACT_APP_MICRSOFT_CLARITY_PROJECT_ID'],
  b2BucketUrl: process.env['REACT_APP_B2_BUCKET_URL'],
  partner: process.env['REACT_APP_PARTNER'],
  isHolidayDiscountActive: process.env['REACT_APP_IS_HOLIDAY_DISCOUNT_ACTIVE'],
  holidayDiscountPercentage:
    process.env['REACT_APP_HOLIDAY_DISCOUNT_PERCENTAGE'],
  holidayDiscountCoupon: process.env['REACT_APP_HOLIDAY_DISCOUNT_COUPON']
};

const envConfig = (key: string) => {
  return _envConfig[key];
};

export default envConfig;
